import { render, staticRenderFns } from "./ModalSettings.vue?vue&type=template&id=22e4fc47&scoped=true&"
import script from "./ModalSettings.vue?vue&type=script&lang=js&"
export * from "./ModalSettings.vue?vue&type=script&lang=js&"
import style0 from "./ModalSettings.vue?vue&type=style&index=0&id=22e4fc47&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e4fc47",
  null
  
)

export default component.exports